import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

const URL_RE = /(https?:\/\/[^\s]+)/g;

const Linkified = ({ text }) => text.split(URL_RE).map((part, i) => (i % 2 ? (
  <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="break-all font-bold text-[#2563eb] underline">{part}</a>
) : <span key={i}>{part}</span>));

export const InfoPopupCard = ({ p, onClose, tid = "info-popup" }) => (
  <div className="relative mx-auto w-full max-w-sm rounded-2xl bg-white p-6 text-center text-slate-800 shadow-2xl" data-testid={tid}>
    <button onClick={onClose} className="absolute right-3 top-3 rounded-full p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700" aria-label="Tutup" data-testid={`${tid}-close`}>
      <X size={18} />
    </button>
    <h3 className="text-lg font-black text-rose-600" data-testid={`${tid}-title`}>{p.title}</h3>
    <p className="mt-3 whitespace-pre-line text-left text-sm font-semibold leading-relaxed" data-testid={`${tid}-body`}><Linkified text={p.body || ""} /></p>
    <button onClick={onClose} className="jp-btn-radius mt-5 w-full bg-[#2563eb] px-4 py-2.5 text-sm font-extrabold text-white transition-colors hover:bg-[#1d4ed8]" data-testid={`${tid}-ok`}>
      {p.button_text}
    </button>
  </div>
);

const KEY = "jp_info_popup_seen";

export const InfoPopup = () => {
  const { popup } = useSiteSettings();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (popup?.enabled && popup.body && !sessionStorage.getItem(KEY)) setOpen(true);
  }, [popup]);
  if (!open) return null;
  const close = () => {
    sessionStorage.setItem(KEY, "1");
    setOpen(false);
  };
  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/70 p-4 backdrop-blur-sm" onClick={close} data-testid="info-popup-overlay">
      <div className="w-full animate-in fade-in zoom-in-95" onClick={(e) => e.stopPropagation()}><InfoPopupCard p={popup} onClose={close} /></div>
    </div>
  );
};
